<template lang="pug">
.content.front
    FrontSolgan
    FrontBeehive
    FrontQAPublic
    FrontLesson
    FrontVideo
</template>
<script>
// import gql from 'graphql-tag'
// import graphql from '../../Model/graphqlfront'
import MdNotification from '@/core/components/mdNotification'
import store from '../../../store'
import FrontSolgan from './Solgan'
import FrontBeehive from './Beehive'
import FrontQAPublic from './QAPublic'
import FrontLesson from './Lesson'
import FrontVideo from './Video'
export default {
  metaInfo: {
    title: 'Obee Website',
    meta: [
      {name: 'description', content: 'I have things here on my site.'}
    ]
  },
  components: {
    MdNotification,
    FrontSolgan,
    FrontBeehive,
    FrontQAPublic,
    FrontLesson,
    FrontVideo,
    store
  },
  data() {
    return {
    }
  },
  methods: {
    getScrollTop(element) {
      if (element === window) return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop)
      return element.scrollTop
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.$route.params.front_top !== undefined && this.$route.params.front_top) {
        window.scrollTo(0, this.$route.params.front_top)
      }
    }, 100)
  },
  apollo: {
  }
}
</script>
<style lang="scss">
.content.front{background: #FBF4D2;
    span.beehive{width: 42px;height: 50px;transform: matrix(0, 1, -1, 0, 0, 0);background: #FFEF45 0% 0% no-repeat padding-box;position: relative;margin-right: 7px;top:-5px;
        img{max-width: 100%; width:30px;}
    }
}
@media (max-width: 1366px){
    .content.front{
    }
}
@media (max-width: 1024px){
    .content.front{
    }
}
@media (max-width: 991px){
    .content.front{
    }
}
@media (max-width: 768px){
    .content.front{
    }
}

@media (max-width: 375px){
    .content.front{
    }
}
@media (max-width: 320px){
    .content.front{
    }
    footer.front{
        .policy{
             a.link{margin-right:10px;}
        }
    }
}
</style>




// WEBPACK FOOTER //
// index.vue?76d3ac96